<template>
  <div class="container p-5 admin_comment_page">
    <div class="container">
      <h3 class="tNormal mb-5">خلاصه سفارش</h3>
      <div class="mb-2 border-bottom">
        <ul class="header">
          <li class="column">تصویر محصول</li>
          <li class="column">نام محصول</li>
          <li class="column">تعداد</li>
          <li class="column">قیمت</li>
          <li class="column">آدرس</li>
          <li class="column">شماره تلفن</li>
        </ul>
        <order-item
          v-for="(item, i) in products"
          :key="i"
          :theItem="item"
        ></order-item>
      </div>
      <div class="mb-2 border-bottom">
        <div v-if="all_data.comment.message" class="clearfix">
          <div class="user-comment w-50 mb-2">
            <div class="user-name">
              {{ all_data.order.original.data.user_name }}:
            </div>
            <div class="user-message">
              {{ all_data.comment.message }}
            </div>
          </div>
          <div v-if="all_data.seller" class="seller-comment mb-3">
            <div class="text-info mb-1">فروشنده:</div>
            <div class="">
              {{ all_data.seller }}
            </div>
          </div>
          <div v-if="all_data.admin" class="admin-comment mb-2">
            <div class="text-primary mb-1">ادمین:</div>
            <div class="">
              {{ all_data.admin }}
            </div>
          </div>
        </div>
      </div>
      <div class="mt-5 p-4 comment-reply">
        <div class="mb-2">ثبت نظر به عنوان:</div>
        <div class="mb-2">
          <button
            @click="as_admin()"
            :class="{ active: adminActive }"
            class="two-state-btn admin"
          >
            ادمین
          </button>
          <button
            @click="as_seller()"
            :class="{ active: sellerActive }"
            class="two-state-btn seller"
          >
            فروشنده
          </button>
        </div>
        <div v-if="reply != null">
          <p class="tBold">پاسخ نظر :</p>
          {{ reply }}
        </div>
        <div v-else>
          <custom-input
            rows="3"
            kind="area"
            container="full-width"
            classes="full-width"
            v-bind:theModel.sync="replyToSend"
            placeholder="پاسخ"
          ></custom-input>
          <button class="purple-btn" @click="sendReply">ثبت پاسخ</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { computed, inject, onMounted, ref } from "@vue/composition-api";
import OrderItem from "../../Order/partials/OrderItem";
import Service from "../../../../utils/admin-service";
import CustomInput from "../../../Common/CustomInput";
export default {
  components: {
    OrderItem,
    CustomInput,
  },
  setup(props, context) {
    const items = ref(null);
    const products = ref(null);
    const all_data = ref(null);
    const authService = computed(() => {
      return Service(true);
    });
    const global = inject("global");
    const reply = ref(null);
    const replyToSend = ref({ value: null, valid: true });
    const getComment = () => {
      authService.value.receive(
        "admin/comment/detail/" + context.root.$route.params.id,
        {},
        (s, d) => {
          all_data.value = d.data;
          products.value = d.data.order.original.data.product;
          products.value.map((p) => {
            p.user_address = d.data.order.original.data.user_address;
            p.user_phone = d.data.order.original.data.user_phone;
          });
          reply.value = d.data.reply;
        },
        (s, e) => {}
      );
    };
    onMounted(() => {
      getComment();
    });

    const sendReply = () => {
      let f = new FormData();
      f.append("message", replyToSend.value.value);
      if (
        sellerActive.value &&
        replyToSend.value.value != null &&
        replyToSend.value.value != ""
      ) {
        f.append("from", 0);
      } else if (
        adminActive.value &&
        replyToSend.value.value != null &&
        replyToSend.value.value != ""
      ) {
        f.append("from", 1);
      }
      authService.value.transmit(
        "admin/comment/reply/" + context.root.$route.params.id,
        f,
        (s, d) => {
          if (s == 200) {
            global.alertToggle("موفقیت آمیز بود!");
            getComment();
          }
        },
        (s, e) => {
          global.alertToggle("عملیات ناموفق!");
        }
      );
    };
    const adminActive = ref(true);
    const sellerActive = ref(false);
    const as_admin = function () {
      adminActive.value = true;
      sellerActive.value = false;
      console.log(adminActive.value)
      console.log(sellerActive.value)
    };
    const as_seller = function () {
      adminActive.value = false;
      sellerActive.value = true;
      console.log(adminActive.value)
      console.log(sellerActive.value)
    };

    return {
      items,
      products,
      reply,
      replyToSend,
      sendReply,
      all_data,
      adminActive,
      sellerActive,
      as_admin,
      as_seller,
    };
  },
};
</script>
<style lang="scss">
.admin_comment_page {
  font-size: 14px;
  .summary {
    background-color: #fff;
    font-size: 0.9rem;
    font-weight: lighter;
  }

  table {
    border-collapse: separate;
    border-spacing: 0px;
    width: 100%;
    table-layout: auto;
  }

  td {
    border: 1px solid rgba(127, 127, 127, 0.2);
    padding-right: 1rem;
    text-align: center;
  }

  th {
    text-align: center;
    padding: 1rem;
  }

  tr {
    width: 100%;
  }

  .big-cell {
    width: 75%;
    padding: 0.5rem 1rem 0.5rem 1rem;
  }

  .small-cell {
    width: 25%;
    padding: 0.5rem 1rem 0.5rem 1rem;
  }

  .accounts {
    border-top: 1px solid rgba(127, 127, 127, 0.2);
  }

  .comment-reply {
    background-color: #ece8e8;
    border-radius: 4px;
  }
  th {
    border-bottom: 1px solid rgb(230, 230, 230);
  }
  .column {
    display: inline-block;
    width: calc(100% / 6);
    text-align: center;
    overflow: auto;
    vertical-align: middle;
    font-size: 13px;
  }
  .header {
    border-bottom: 1px solid rgb(230, 230, 230);
  }
  .user-name {
    color: rgb(255, 14, 183);
    margin-bottom: 5px;
    font-size: 12px;
  }
  .user-message {
    font-size: 12px;
    padding-right: 20px;
    padding-bottom: 10px;
  }
  .admin-comment {
    font-size: 12px;
    padding-right: 5%;
  }
  .seller-comment {
    font-size: 12px;
    padding-right: 12%;
  }
  .two-state-btn {
    padding: 10px;
    background: rgb(104, 104, 104);
    outline: none;
    &.admin {
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
    }
    &.seller {
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
    }
    &.active {
      background: #859bef;
      color: white;
      box-shadow: 1px 1px 5px #1b2d75;
    }
  }
}
</style>